
import React, { Component } from 'react';

import {getFeatureByTag} from 'reducers/features.js'
import UserUtils from 'utils/UserUtils.js';
import UAParser from 'ua-parser-js';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import {setNavbarCloseButtonEnable, setNavbarDoneButtonEnable} from 'actions/navbar.js';
import {fetchBadgeNumbers} from 'actions/user.js';
import {colors} from 'style';

import NavBar from './NavBar.js';
import DatabaseService from '../../services/DatabaseService.js';

var eventListeners = {
    onClose:[],
    onDone:[]
}

const seconds = 1000;
const minutes = 60*seconds;

class NavBarContainer extends Component
{
    constructor(props) {
        super(props);
        this.state = {showPopUpMenu:false};
        this.onBack = this.onBack.bind(this);
        this.onClose= this.onClose.bind(this);
        this.onDone= this.onDone.bind(this);
        this.toggleSideBar = this.toggleSideBar.bind(this);
        this.onClickLink = this.onClickLink.bind(this);
        this.onTogglePopUpMenu = this.onTogglePopUpMenu.bind(this);
        this.onShowPopUpMenu = this.onShowPopUpMenu.bind(this);
        this.onSignOut = this.onSignOut.bind(this);
        this.includeLink = this.includeLink.bind(this);

        //badge number polling
        this.timerId = null;
        this.pollDuration = 10*minutes;
        this.poll = this.poll.bind(this);
    }

    componentWillMount() {
        this.startPolling();
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    startPolling() {
        if(this.timerId===null) {
            this.timerId = setInterval(this.poll, this.pollDuration);
        }
    }

    stopPolling() {
        if(this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }

    poll() {
        if(this.props.isLoggedIn && this.props.userProfile) {
            this.props.dispatch(fetchBadgeNumbers());
        }
    }

    onBack(event) {
        this.props.history.goBack();
    }

    onClose() {
        eventListeners.onClose.forEach(onClose => onClose());
    }

    onDone() {
        eventListeners.onDone.forEach(onDone => onDone());
    }

    toggleSideBar() {
        this.props.dispatch({type:"TOGGLE_SIDEBAR"});
    }

    links() {
        var links = [
                    {href:"/leaderboards",      title:"Leaderboards",    iconClassName:"icon-leaderboard"},
                    {href:"/myprogress",      title:"My Progress",    iconClassName:"icon-leaderboard"},
                    {href:"/team-challenges",    title:"Team Challenge",  iconClassName:"icon-team"},
                    {href:"/connections",       title:"Integrations",    iconClassName:"icon-signal"},
                    {href:"/rewards",           title:"Rewards",         iconClassName:"icon-rewards"},
                    {href:"/newsfeed",           title:"Community",    iconClassName:"icon-newsfeed"},
        ];
        return links.filter(this.includeLink).map((link)=>({...link, className: 'item'}));
    }

    includeLink(link) {
        if(!this.props.teamChallengeFeature && link.href==='/team-challenges') {
            return false; 
        }
        return true;
    }

    popUpMenuLinks() {
        var parser = new UAParser();
        var UAParsed = parser.getResult();
        var feedback ="mailto:support@myoptimity.com?subject=Feedback&body=I%20have%20some%20feedback%0A%0APlease%20enter%20your%20feedback%20here:%0A%0A%0A"
                        + "%0AEmail:%20" + this.props.email
                        + "%0ABrowser%20Name:%20" + UAParsed.browser.name 
                        + "%20%0ABrowser%20Version:%20"+ UAParsed.browser.version 
                        + "%0ASystem%20Name:%20" + UAParsed.os.name
                        + "%0ASystem%20Version:%20" + UAParsed.os.version 
                        + "%0AEngine:%20" + UAParsed.engine.name 
                        + "%0AEngine Version:%20" + UAParsed.engine.version;
        var links = [
                    {href:"/profile",     title:"Profile", onClick:this.onClickLink},
                    {href:"/invitations", title:"Invite Friends", onClick:this.onClickLink},
                    {href:"/settings",    title:"Settings", onClick:this.onClickLink},
                    {href:"https://myoptimity.cnflx.io/public",           title:"Request a New Feature",         iconClassName:"icon-rewards"},
                    {href:feedback,          title:"Feedback",        iconClassName:"icon-news"},
                    {href:"/login",    title:"Sign Out", onClick:this.onSignOut, style: {
                        color: colors.warningRed
                    }},
        ];
        return links;
    }

    onClickLink(e) {
        e.preventDefault();
        var href = e.currentTarget.getAttribute('href');
        if(href.startsWith('http')) {
            window.location = href;
        } else {
            this.props.history.push(href);
            this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
            this.setState({showPopUpMenu: false});
        }
    }

    onTogglePopUpMenu(e) {
        this.setState(s => ({showPopUpMenu:!s.showPopUpMenu}));
    }

    onShowPopUpMenu(en) {
        this.setState({showPopUpMenu:en});
    }

    onSignOut(e){
        e.preventDefault();
        DatabaseService.signOut();
    }

    render() {
        return <NavBar {...this.state}
                       title={this.props.title}
                       enable={this.props.enable}
                       rewardsEnable={this.props.rewardsEnable}
                       menuEnable={this.props.menuEnable}
                       logoutButtonEnable={this.props.logoutButtonEnable}
                       backButtonEnable={this.props.backButtonEnable}
                       closeButtonEnable={this.props.closeButtonEnable}
                       closeIconOpts={this.props.closeIconOpts}
                       doneButtonEnable={this.props.doneButtonEnable}
                       doneIconOpts={this.props.doneIconOpts}
                       sideBarOpen={this.props.sideBarOpen}
                       resources={this.props.resources}
                       points={this.props.points}
                       avatarUrl={this.props.avatarUrl}
                       badgeNumbers={this.props.badgeNumbers}
                       mode={this.props.mode}
                       links={this.links()}
                       popUpMenuLinks={this.popUpMenuLinks()}
                       onBack={this.onBack}
                       onClose={this.onClose}
                       onDone={this.onDone}
                       onClickMenuButton={this.toggleSideBar}
                       onTogglePopUpMenu={this.onTogglePopUpMenu}
                       onShowPopUpMenu={this.onShowPopUpMenu}
                       onSignOut={this.onSignOut}
                       onClickLink={this.onClickLink}/>; 
    }
}

function mapStateToProps(state, ownProps) {
    var resources = state.user.userProfile ? (state.user.userProfile.resources || 0) : null;
    var points    = state.user.userProfile ? (state.user.userProfile.points    || 0) : null;
    var email = state.user.userProfile ? (state.user.userProfile.email || 'N/A') : '';
    var avatarUrl = state.user.userProfile ? UserUtils.getAvatarURL(state.user.userProfile) : null;
    var badgeNumbers = state.user.badgeNumbers;
    var teamChallengeFeature = getFeatureByTag(state.features, 'optimity_team_challenge'); 
    return {...state.navbar, 
            resources:resources, 
            points:points, 
            userProfile: state.user.userProfile,
            isLoggedIn:state.user.loggedIn,
            avatarUrl: avatarUrl,
            sideBarOpen: state.sidebar.enable,
            badgeNumbers:badgeNumbers,
            email: email,
            teamChallengeFeature};
}

export default withRouter(connect(mapStateToProps)(NavBarContainer));




class NavControl extends Component
{
    constructor(props) {
        super(props);
        //console.log('NavControl constructor', this);
        this.onClose = this.onClose.bind(this);
        this.onDone= this.onDone.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        //console.log('NavControl componentWillReceiveProps', nextProps);
        var closeOptsKey = this.props.closeIconOpts ? this.props.closeIconOpts.key : null;
        var nextCloseOptsKey = nextProps.closeIconOpts ? nextProps.closeIconOpts.key : null;
        var onCloseEn = Boolean(this.props.onClose);
        var nextOnCloseEn = Boolean(nextProps.onClose);
        if(closeOptsKey!==nextCloseOptsKey || onCloseEn!==nextOnCloseEn) {
            //console.log('NavControl update closebutton', nextOnCloseEn, nextProps.closeIconOpts);
            this.props.dispatch(setNavbarCloseButtonEnable(nextOnCloseEn, nextProps.closeIconOpts));
        }
        var doneOptsKey = this.props.doneIconOpts ? this.props.doneIconOpts.key : null;
        var nextDoneOptsKey = nextProps.doneIconOpts ? nextProps.doneIconOpts.key : null;
        var onDoneEn = Boolean(this.props.onDone);
        var nextOnDoneEn = Boolean(nextProps.onDone);
        if(doneOptsKey!==nextDoneOptsKey || onDoneEn!==nextOnDoneEn) {
            this.props.dispatch(setNavbarDoneButtonEnable(nextOnDoneEn, nextProps.doneIconOpts));
        }
    }

    componentDidMount() {
        //console.log('NavControl componentDidMount', this);
        eventListeners.onClose.push(this.onClose);
        eventListeners.onDone.push(this.onDone);
        if(this.props.onClose || this.props.closeIconOpts) {
            this.props.dispatch(setNavbarCloseButtonEnable(Boolean(this.props.onClose), this.props.closeIconOpts));
        }
        if(this.props.onDone || this.props.doneIconOpts) {
            this.props.dispatch(setNavbarDoneButtonEnable(Boolean(this.props.onDone), this.props.doneIconOpts));
        }
    }
    componentWillUnmount() {
        eventListeners.onClose = eventListeners.onClose.filter(onClose => onClose!==this.onClose);
        this.props.dispatch(setNavbarCloseButtonEnable(false));
        eventListeners.onDone = eventListeners.onDone.filter(onDone => onDone!==this.onDone);
        this.props.dispatch(setNavbarDoneButtonEnable(false));
    }
    onClose() {
        if(this.props.onClose) {
            this.props.onClose();
        }
    }
    onDone() {
        if(this.props.onDone) {
            this.props.onDone();
        }
    }
    render() {
        return React.Children.only(this.props.children);
    }
};
const NavControlConnect = connect()((NavControl));
export {NavControlConnect as NavControl};



// WEBPACK FOOTER //
// ./src/modules/navigation/NavBarContainer.js